import { useEffect, useRef } from 'react';
import { isEmpty } from 'lodash-es';
import { map, omit, pick, prop } from 'ramda';
import { parseSearchParams } from '@namespace/helpers';
import { IS_WIDGET } from '@namespace/widget';
import { useFiltersCtxActions } from '../store';

export const useInitializeFilter = ({ filterConfig, initialFilterData }) => {
  const isSet = useRef(false);
  const { SET_FILTER } = useFiltersCtxActions();

  useEffect(() => {
    if (isSet.current) {
      return;
    }

    isSet.current = true;
    const searchParams = parseSearchParams(window.location.search);

    // todo, temporary fix for FCW-816
    const filterKeys = filterConfig.some((item) => item.key === 'dateOptionId')
      ? [...new Set(map(prop('key'), filterConfig)), 'startDate', 'endDate']
      : map(prop('key'), filterConfig);

    const filterDataFromSearchParams = pick(filterKeys, searchParams);
    const actualFilterDataFromSearchParams = IS_WIDGET
      ? omit(filterDataFromSearchParams, 'widget')
      : filterDataFromSearchParams;

    const filterData =
      // take filter data from search param if they exist, otherwise initial data from config
      isEmpty(actualFilterDataFromSearchParams)
        ? initialFilterData
        : actualFilterDataFromSearchParams;

    SET_FILTER(filterData);
  }, [SET_FILTER, filterConfig, initialFilterData]);
};
